export const URL = {
  // RECUPERATION
  fetchActors: "https://theatre.startwin.fr/actors", // tout les acteurs
  fetchActorsByPlay: "https://theatre.startwin.fr/actors/play/", // + le nom de la piece
  fetchActorsPR: "https://theatre.startwin.fr/actors/Palais Royal",
  fetchActorsM: "https://theatre.startwin.fr/actors/Michel", 
  fetchActorsById: "https://theatre.startwin.fr/actors/actor/id/", // + id de l'acteur

  fetchLieux: "https://theatre.startwin.fr/locations", // tout les lieux
  fetchLieuxPR: "https://theatre.startwin.fr/locations/Palais Royal", 
  fetchLieuxM: "https://theatre.startwin.fr/locations/Michel", 
  fetchLieuxPRById: "https://theatre.startwin.fr/locations/Palais Royal/id/", // + id
  fetchLieuxMById: "https://theatre.startwin.fr/locations/Michel/id/", // + id 

  fetchPieces: "https://theatre.startwin.fr/plays", // toutes les pieces
  fetchPiecesPR: "https://theatre.startwin.fr/plays/Palais Royal", 
  fetchPiecesM: "https://theatre.startwin.fr/plays/Michel", 
  fetchPiecesPRById: "https://theatre.startwin.fr/plays/Palais Royal/", // + id
  fetchPiecesMById: "https://theatre.startwin.fr/plays/Michel/", // + id

  fetchActualite: "https://theatre.startwin.fr/news", // tout les lieux
  fetchActualitePR: "https://theatre.startwin.fr/news/Palais Royal", 
  fetchActualiteM: "https://theatre.startwin.fr/news/Michel", 
  fetchActualitePRById: "https://theatre.startwin.fr/news/Palais Royal/id/", // + id
  fetchActualiteMById: "https://theatre.startwin.fr/news/Michel/id/", // + id

  fetchUsers: "https://theatre.startwin.fr/users",
  verifyUsers: "https://theatre.startwin.fr/users/check-user-exists",
  
  // ENREGISTREMENT
  postActeur: "https://theatre.startwin.fr/actors/post",
  
  // SUPPRESSION
  suppActeur: "https://theatre.startwin.fr/actors/delete/", // + id
}